module.exports = __webpack_public_path__ + "static/media/5_14.71b7dc67.png";